import React, { Fragment } from 'react'

const HeaderColor = () => {
    return (
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 dashBoard">
                        <h2>Color Management</h2>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default HeaderColor